<div class="table-responsive">
  <table class="table table-borderless table-hover">
    <thead>
      <tr>
        <th class="p-0 pr-2"></th>
        <th style="min-width: 90px"></th>
        <th scope="col" translate>ORDER_ID</th>
        <th scope="col" translate>CUSTOMER_NAME</th>
        <th scope="col" translate>OUR_REFERENCE</th>
        <th scope="col" translate>ORDER_DATE</th>
        <th scope="col" translate>EXPECTED_DELIVERY_DATE</th>
        <th scope="col" translate>COMPLETE_PERCENT</th>
        <th scope="col" translate>TOTAL</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let order of data"
        [routerLink]="[order.id]"
      >
        <td class="p-0 border-0" [ngClass]="{
          'not-invoiced': order.extra.Order.InvoiceReference === '0',
          invoiced: order.extra.Order.InvoiceReference !== '0',
          cancelled: order.extra.Order.Cancelled === true
        }"></td>
        <td style="width: 90px">
          <lib-item-selection-button [item]="order"></lib-item-selection-button>
        </td>
        <td>
          <a>{{ order.id }}</a>
        </td>
        <td>{{ order.extra.Order.CustomerName || '-' }}</td>
        <td>{{ order.extra.Order.OurReference }}</td>
        <td>
          <span *ngIf="order.extra.Order.OrderDate" class="{{ getCssClass(order) }}">
            {{ order.extra.Order.OrderDate | date: dateUtilService.dateFormat }}
          </span>
        </td>
        <td>
          <span *ngIf="order.extra.Order.DeliveryDate" class="{{ getCssClass(order) }}">
            {{ order.extra.Order.DeliveryDate | date: dateUtilService.dateFormat }}
          </span>
        </td>
        <td [ngStyle]="{
              'color': 
                (order.extra.Order.Net_Original / order.extra.Order.Net * 100) >= 90 ? 'green' :
                (order.extra.Order.Net_Original / order.extra.Order.Net * 100) >= 70 ? '#ff8c00' :
                'red'
            }">
          {{
            ((order.extra.Order.Net_Original / order.extra.Order.Net) * 100) | number:'1.0-0'
          }}%
        </td>
        <td>
          {{ gungCurrencyPipe.transform(order.extra.Order.Total, order.extra.Order.Currency, 'symbol-narrow', '1.2-2') }}
        </td>
        <td (click)="$event.stopPropagation()">
          <div 
            *ngIf="order.extra.Order.Remarks" 
            class="remark-container"
            (click)="toggleRemark($event, order.id)"
            [class.active]="activeRemarkId === order.id">
            <span class="remark-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </span>
            <div class="remark-tooltip">
              {{ order.extra.Order.Remarks }}
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>